const webinarListSection = $('#list-section');
const webinarSlider = webinarListSection.find('.slider-nav-parent');
const webinarsPagesList = webinarListSection.find('.webinars-list-parent');
const webinarsPages = webinarListSection.find('.webinars-list-page');
const webinarsCards = webinarListSection.find('.webinars-list-card-placer');
const navBtns = webinarSlider.find('.slider-nav-btn');
let webinarsListTL, webinarToperListInTL;
let webinarLastPage = 0;

const setWebinarListCards = () => {
  webinarsCards.each(function () {
    const cardPersonParent = $(this).find('.webinar-list-card-photos-parent');
    const cardPersonOverflow = $(this).find('.webinar-list-card-photos-overflow');
    const cardPersonPhotos = $(this).find('.webinar-list-card-multiply-photo');
    const personPhotosCount = cardPersonPhotos.length;
    const photoWidth = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoHeight = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoOffset = isDesktop() ? 2 : isTablet() ? 3.276 : 6.389;
    if (personPhotosCount != 0) {
      cardPersonOverflow.width(
        `${photoWidth * personPhotosCount - (photoWidth - photoOffset) * (personPhotosCount - 1)}vw`
      );
      cardPersonOverflow.height(`${photoHeight}vw`);
      cardPersonPhotos.each(function (index) {
        $(this).css({
          left: `${photoOffset * index}vw`,
          'z-index': `${personPhotosCount * 100 - index}`,
        });
      });
    } else {
      gsap.set(cardPersonParent, { display: 'none' });
    }
  });
};

const webinarCardHover = (card, direction) => {
  const cardImageParent = card.find('.webinars-list-card-image-parent');
  const isBig = card.hasClass('big');
  const toWidth = direction == 1 ? (isBig ? '33.688vw' : '15.25vw') : isBig ? '30.625vw' : '13.75vw';
  gsap.to(cardImageParent, {
    height: toWidth,
    duration: 0.667,
    ease: 'tagInEasing',
    overwrite: 'auto',
  });
};

const webinarCardsIn = () => {
  const firstPageCards = webinarsPages.slice(webinarLastPage).find('.webinars-list-card-placer');
  const otherCards = webinarsCards.not(firstPageCards);
  const cardsInTL = gsap.timeline({ paused: true });
  cardsInTL.add(
    gsap.fromTo(
      firstPageCards,
      {
        x: `${98.125}vw`,
      },
      {
        x: 0,
        duration: 1,
        ease: 'tagInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  cardsInTL.add(
    gsap.fromTo(
      firstPageCards,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        ease: 'opacityInEasing',
        stagger: {
          each: 0.1,
          from: 'start',
        },
      }
    ),
    0
  );
  return cardsInTL;
};

const webinarScrollPage = (slider, sliderObject, direction, from, to) => {
  const prevCards = sliderObject.slice(from).find('.webinars-list-card-placer');
  const nextCards = sliderObject.slice(to).find('.webinars-list-card-placer');
  const allCards = $('.webinars-list-card-placer');

  const excludedCards = prevCards.add(nextCards);
  const remainingCards = allCards.not(excludedCards);

  const pageWidth = pxToVw(webinarsPages.eq(0).outerWidth());
  const pagesGap = pxToVw(Number(webinarsPagesList.css('gap').replace('px', '')));
  const offset = pageWidth + pagesGap;

  gsap.to(prevCards, {
    x: `${-offset * to}vw`,
    duration: 1,
    ease: 'tagInEasing',
    stagger: {
      each: 0.03,
      from: direction == 1 ? 'start' : 'end',
    },
  });
  gsap.to(nextCards, {
    x: `${-offset * to}vw`,
    duration: 1,
    ease: 'tagInEasing',
    stagger: {
      each: 0.033,
      from: direction == 1 ? 'start' : 'end',
    },
    delay: direction == 1 ? 0.165 : 0,
    onComplete: () => slider.attr('data-is-blocked', 'none'),
  });
  if (remainingCards.length != 0) {
    gsap.set(remainingCards, {
      x: `${-offset * to}vw`,
    });
  }
};

const changeSliderControls = () => {
  setWebinarListCards();
  webinarsCards.each(function () {
    const cardImage = $(this).find('.webinars-list-card-image-parent');
    gsap.killTweensOf(cardImage);
    gsap.set(cardImage, {
      clearProps: 'all',
    });
    $(this).off('mouseenter mouseleave');
    if (isDesktop()) {
      $(this).on('mouseenter', () => webinarCardHover($(this), 1));
      $(this).on('mouseleave', () => webinarCardHover($(this), 0));
    }
  });
};

const webinarListIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionTopperInTL = gsap.timeline({ paused: true });
  const sectionInTL = gsap.timeline({ paused: true });

  sectionTopperInTL.add(
    animateSectionTopperIn({
      sectionParent: webinarListSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  sectionInTL.add(webinarCardsIn().play(), 0.5);
  return [sectionTopperInTL, sectionInTL];
};

const initWebinarList = () => {
  changeSliderControls();

  $(window).on('deviceChange', function () {
    changeSliderControls();
  });

  addStepAnimation(webinarSlider, webinarsPages, webinarScrollPage);

  if(isDesktop()){
    [webinarToperListInTL, webinarsListTL] = webinarListIn();
      ScrollTrigger.create({
      trigger: webinarListSection,
      start: 'top top+=120%',
      end: 'top top+=50%',
      once: true,
      onUpdate: (self) => {
        webinarToperListInTL.progress(self.progress);
      },
    });
    ScrollTrigger.create({
      trigger: webinarListSection,
      start: 'top+=30% bottom',
      end: 'top top',
      once: true,
      onEnter: () => {
        webinarsListTL.play();
      },
    });
  }
  addSliderInAnimation(webinarSlider, true, 50, true);
}

/*
$(window).on('heroReady', () => {
  initWebinarList();
});
*/

addSectionObserver(webinarListSection, initWebinarList);